import { render, staticRenderFns } from "./ModalDocumentAction.vue?vue&type=template&id=5e9cff0c&scoped=true&"
import script from "./ModalDocumentAction.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9cff0c",
  null
  
)

export default component.exports